module.exports = __webpack_public_path__ + "static/img/kjdy13.07c5c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy13.png
// module id = 135
// module chunks = 0